import React, { useState } from 'react';
import { ModalOverlay } from '../Modal';
import { ModaNetworkForm } from './ModaNetworkForm';
import { ModaNetworkSuccessMessage } from './ModaNetworkSuccessMessage';
import './ModaNetworkRequestModal.scss';

enum Mode {
  Idle,
  Success
}

type Props = {
  show: boolean;
  onClose: () => void;
};

export const ModaNetworkRequestModal: React.FC<Props> = ({ show, onClose }) => {
  const [mode, setMode] = useState(Mode.Idle);

  return (
    <ModalOverlay show={show} onClose={onClose}>
      <div className="ModaNetworkRequestModal">
        {mode === Mode.Idle && (
          <ModaNetworkForm onClose={onClose} onSuccess={() => setMode(Mode.Success)} />
        )}
        {mode === Mode.Success && <ModaNetworkSuccessMessage onClose={onClose} />}
      </div>
    </ModalOverlay>
  );
};
